<template>
  <div class="editForm">
    <el-dialog
      class="customDialog"
      title="编辑"
      :visible.sync="isShow"
      width="890px"
      @close="closeDialog"
      :close-on-press-escape = 'false'
      top="15vh"
      :close-on-click-modal = 'false'
    >
      <div class="formContainer">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <el-form-item :label="item.label+'：'" v-for="item in _columns" :key="item.id">
            <span slot="label" :title="item.label">{{item.label}}：</span>
            <el-input v-model="dynamic[item.id]"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" :loading="true" v-if="loading"></el-button>
        <el-button type="primary" @click="submitForm()" v-else>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { editRowData } from '@/api/dataManagement'
export default {
  name: 'editForm',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: null
    },
    tableId: {
      type: Number,
      default: 0
    },
    currentRow: {
      type: Object,
      default: null
    }
  },
  components: { },
  data () {
    return {
      loading: false,
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ]
      },
      dynamic: {},
      uniqueId: ''
    }
  },
  computed: {
    isShow: {
      get: function (v) {
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    },
    _columns () {
      this.$nextTick(() => {
        this.dynamic = {}
        this.columns.forEach((item) => {
          this.$set(this.dynamic, item.id, '')
        })
      })
      return this.columns
    },
    _currentRow () {
      return this.currentRow
    }
  },
  watch: {
    _currentRow: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.uniqueId = newValue.uniqueId
          this.$nextTick(() => {
            this.columns.forEach((item) => {
              this.$set(this.dynamic, item.id, newValue[item.id])
            })
          })
        }
      }
    }
  },
  methods: {
    submitForm () {
      this.loading = true
      const params = {
        uniqueId: this.uniqueId,
        values: []
      }
      Object.keys(this.dynamic).forEach(k => {
        params.values.push({
          propertyId: k,
          value: this.dynamic[k]
        })
      })
      editRowData(params).then(res => {
        if (res.code === 200) {
          this.$Message('success', res.msg || '操作成功！')
          this.$emit('refreshTable')
          this.isShow = false
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    cancel () {
      this.isShow = false
    },
    closeDialog () {
      this.loading = false
      this.$refs.ruleForm.resetFields()
      this.dynamic = this.$options.data().dynamic
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .editForm{
    .el-form-item__label{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
<style lang="scss" scoped>
.formContainer{
  max-height: 300px;
  overflow: auto;
}
</style>
